import {SpinnerProps, Spinner, Center} from 'platform/foundation';

export function CommonSkeleton(props: SpinnerProps) {
  return (
    <Center data-testid="common-skeleton" width="100%" height="100%">
      <Spinner {...props} data-testid="common-skeleton-spinner" />
    </Center>
  );
}
